import React, { useState } from "react";
import "./PnLCompareFloorplans.scss";
import PlusSignIcon from "./PlusSignIcon";
import { useDispatch, useSelector } from "react-redux";
import PnLFloorplansLot from "../PnLFloorplansLot/PnLFloorplansLot";
import PnLCompareDetails from "./PnLCompareDetails";
import { BackArrow } from "../PnLFloorplanDetails/PnLFloorplanIconsSvg";
import { useHistory } from "react-router-dom";
import {
    filterCompareFloorplans,
    filterFloorplans,
    updateCompareProductFilterValue,
    updateProductFilterValue,
} from "../../redux/actions/floorplanActions";
import { useScrollBoost } from "react-scrollbooster";

function CompareLotFilterRadio(props) {
    var classes = "CompareLotFilterRadio";
    if (props.selected) classes += " selected";

    function handleClick(side, index, value) {
        props.callback(side, index, value);
    }

    return (
        <button
            className={classes}
            onClick={() => handleClick(props.side, props.index, props.value)}
        >
            <div className="circle"></div>
            <div className="label">{props.label} Lots</div>
        </button>
    );
}

function PnLCompareFloorplans(props) {
    var dispatch = useDispatch();
    var history = useHistory();
    var activeCompare = useSelector(
        (state) => state.floorplan.activeCompareFloorplans
    );
    //var lots = useSelector(state => state.floorplan.floorplans);
    var lots = useSelector((state) => state.floorplan.activeFloorplans);
    var compareLots = useSelector((state) => state.floorplan.compareFloorplans);

    var icons = useSelector((state) => state.content.pages.floorplans);

    var products = useSelector((state) => state.floorplan.products);
    var productFilterID = useSelector(
        (state) => state.floorplan.productFilterID
    );
    var compareProductFilterID = useSelector(
        (state) => state.floorplan.compareProductFilterID
    );

    var left = activeCompare.left;
    var right = activeCompare.right;

    var [leftOpen, setLeftOpen] = useState(left.activeFloorplanID != -1);
    var [rightOpen, setRightOpen] = useState(right.activeFloorplanID != -1);

    var isTouchScreen = useSelector((state) => state.utilities.isTouchScreen);

    var [viewport] = useScrollBoost({
        direction: "all",
        friction: 0.05,
        scrollMode: "native",
        bounce: false,
        onClick: (state, event) => {
            if (state.isDragging) {
                event.preventDefault();
            }
        },
    });

    var classes = "PnLCompareFloorplans";
    var backClasses = "compare-back-bar";

    if (leftOpen || rightOpen) {
        backClasses += " closed";
        classes += " closed";
    }

    if (isTouchScreen) {
        classes += " touchscreen";
        backClasses += " touchscreen";
    }

    function getSelectButtonContainer(callback) {
        return (
            <div className="select-button-container">
                <button
                    className="select-button"
                    onClick={() => callback(true)}
                >
                    <PlusSignIcon />
                    <span className="label">
                        select floorplan
                        <br />
                        to compare
                    </span>
                </button>
            </div>
        );
    }

    function getCompareFloorplanList(side) {
        //we are left side
        //we need teh floorplans

        var filterID = -1;

        if (side == "left") filterID = productFilterID;
        else filterID = compareProductFilterID;

        function lotFilterOnClickCallBack(side, index, value) {
            //obvious
            if (side == "left") {
                dispatch(updateProductFilterValue(index, value));
                dispatch(filterFloorplans());
            } else {
                dispatch(updateCompareProductFilterValue(index, value));
                dispatch(filterCompareFloorplans());
            }
        }

        function displayListContainer(
            side,
            activeLots,
            displayElevation = false
        ) {
            //same as the other one

            if (displayElevation) {
                return (
                    <React.Fragment>
                        {activeLots.map((lot, lkey) => (
                            <React.Fragment>
                                {lot.elevation.map((elv, ekey) => (
                                    <PnLFloorplansLot
                                        lot={lot}
                                        elv={elv}
                                        lotIndex={lkey}
                                        elvIndex={ekey}
                                        icons={icons}
                                        compare
                                        side={side}
                                    />
                                ))}
                            </React.Fragment>
                        ))}
                    </React.Fragment>
                );
            } else {
                return (
                    <React.Fragment>
                        {activeLots.map((lot, lkey) => (
                            <PnLFloorplansLot
                                lot={lot}
                                elv={lot.elevation[0]}
                                lotIndex={lkey}
                                elvIndex={0}
                                icons={icons}
                                side={side}
                                compare
                            />
                        ))}
                    </React.Fragment>
                );
            }
        }

        return (
            <div className="compare-floorplan-viewport" ref={viewport}>
                <div className="compare-floorplan-container">
                    <div className="compare-title-bar">
                        <div className="heading">Select Floorplan</div>
                        <div className="lot-filter-container">
                            <CompareLotFilterRadio
                                value="all"
                                label="All"
                                index={-1}
                                selected={filterID == -1}
                                callback={lotFilterOnClickCallBack}
                                side={side}
                            />
                            {products &&
                                products.map((product, pkey) => (
                                    <CompareLotFilterRadio
                                        value={product.term_id}
                                        label={product.name}
                                        index={pkey}
                                        selected={pkey == filterID}
                                        callback={lotFilterOnClickCallBack}
                                        side={side}
                                    />
                                ))}
                        </div>
                    </div>
                    {side == "left" && displayListContainer(side, lots)}
                    {side == "right" && displayListContainer(side, compareLots)}
                </div>
            </div>
        );
    }

    if (typeof lots !== "undefined" && typeof icons !== "undefined") {
        icons = icons.floorplan_product_icons;

        return (
            <div className={classes}>
                <div className={backClasses}>
                    <button
                        className="back-button"
                        onClick={() => history.push("/floorplans/list")}
                    >
                        <BackArrow />{" "}
                        <span className="label">Back to Floorplans</span>
                    </button>
                    <div className="heading">Compare Floorplans</div>
                </div>
                <div className="compare-left-container compare-container">
                    {leftOpen && left.activeFloorplanID != -1 && (
                        <PnLCompareDetails side="left" />
                    )}
                    {leftOpen &&
                        left.activeFloorplanID == -1 &&
                        getCompareFloorplanList("left")}
                    {!leftOpen && getSelectButtonContainer(setLeftOpen)}
                </div>
                <div className="compare-right-container compare-container">
                    {rightOpen && right.activeFloorplanID != -1 && (
                        <PnLCompareDetails side="right" />
                    )}
                    {rightOpen &&
                        right.activeFloorplanID == -1 &&
                        getCompareFloorplanList("right")}
                    {!rightOpen && getSelectButtonContainer(setRightOpen)}
                </div>
            </div>
        );
    } else {
        return <div></div>;
    }
}

export default PnLCompareFloorplans;

